export function getSegmentIdFromQuery(query, segmentList) {
  if (query && query.segmentId) {
    let parsedSegmentId = parseInt(query.segmentId)
    if (_.keyBy(segmentList, 'id')[parsedSegmentId]) {
      return parsedSegmentId
    }
  }
  return undefined
}

export function isSegmentHidden(segment) {
  return segment.status === 'HIDDEN'
}

export function getSegmentSelection(selectedSegmentId, segments) {
  return _.filter(segments, (segment) => !isSegmentHidden(segment) || segment.id === selectedSegmentId)
}

export function segmentIdsToSegmentSet(segmentIds) {
  return segmentIds.slice().sort().join(',')
}



// WEBPACK FOOTER //
// ./src/scripts/utils/SegmentSelectHelper.js